export const environment = {
  production: true,
  development: true,
  versionCheckURL : `https://${location.hostname}/version.json`,
  authUrl: `https://${location.hostname}/api/auth`,
  coreUrl: `https://${location.hostname}/api/core`,
  thermalUrl: `https://${location.hostname}/api/thermal`,
  calibratesUrl: `https://${location.hostname}/api/calibrates`,
  airUrl: `https://${location.hostname}/api/air`,
  qualificatesUrl: `https://${location.hostname}/api/qualificates`,
  equipmentUrl:`https://${location.hostname}/api/equipments`,
  signatureUrl: `https://${location.hostname}/api/signature`,
  notificationlUrl:  `https://${location.hostname}/api/notification`,
  autorizationTokenUrl: `https://${location.hostname}/api/token`,
  clientsUrl: `https://${location.hostname}/api/clients`,
  particlesUrl:`https://${location.hostname}/api/particles`,
  balancesUrl: `https://${location.hostname}/api/balance`,
  timeStamp: '4.0.0',
  stripeKey: 'pk_test_51H2g2TFQmNGfNDY5whQKXCuhDf8pXKOipwVU6R2POXovSaByPIEILpNmCUpdLxpywXOyGLGuHEicRgsabTZ2as6P00UEOllOGj',
  hideLangs: false,
  broadcastChannel: 'qloud-desa'
};
